<template>
  <div class="brand-container">
    <Ticker />
    <div class="brand-item title">
      <div v-if="!uploadedImageName">
        {{ brandName }}
      </div>
      <div v-if="uploadedImageName">
        <img
          :src="uploadedImageName"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import Ticker from '@/components/Ticker';

export default {
  name: 'Brand',
  components: {
    Ticker
  },
  data() {
    return {
      theTime: ''
    };
  },
  computed: {
    brandName() {
      return this.$store.state.bookieName;
    },
    uploadedImageName() {
      return `${this.$store.state.webUrl}/uploads/${this.$store.state.screenConfig.uploadedImageName}`;
    }
  },
  created() {
    console.log('Brand component');
  }
};
</script>
<style>
html {
  height: 100%
}
body {
  height: 100%
}
.app-container {
  height: 100%;
}
.startup-container {
  height: 100%;
}
.screen-config-container {
  height: 100%;
}
.brand-container {
  display: flex;
  flex-flow: column;
  height: 100%;
  justify-content: center;
  text-align: center;
}
.brand-item {
  font-size: 100px;
}
.brand-item.title {
  font-size: 100px;
}
.brand-item.sub-title {
  font-size: 50px;
}
</style>


// WEBPACK FOOTER //
// Brand.vue?98f5fcce